import actions from '@cms/i18n/locale/nl_BE/actions.json';
import articleblock from '@cms/i18n/locale/nl_BE/articleblock.json';
import articles from '@cms/i18n/locale/nl_BE/articles.json';
import author from '@cms/i18n/locale/nl_BE/author.json';
import betting from '@cms/i18n/locale/nl_BE/betting.json';
import comments from '@cms/i18n/locale/nl_BE/comments.json';
import common from '@cms/i18n/locale/nl_BE/common.json';
import competitions from '@cms/i18n/locale/nl_BE/competitions.json';
import components from '@cms/i18n/locale/nl_BE/components.json';
import contact from '@cms/i18n/locale/nl_BE/contact.json';
import createPost from '@cms/i18n/locale/nl_BE/create-post.json';
import datetime from '@cms/i18n/locale/nl_BE/datetime.json';
import error from '@cms/i18n/locale/nl_BE/error.json';
import footer from '@cms/i18n/locale/nl_BE/footer.json';
import image from '@cms/i18n/locale/nl_BE/image.json';
import livescores from '@cms/i18n/locale/nl_BE/livescores.json';
import meta from '@cms/i18n/locale/nl_BE/meta.json';
import names from '@cms/i18n/locale/nl_BE/names.json';
import newslist from '@cms/i18n/locale/nl_BE/newslist.json';
import playerRating from '@cms/i18n/locale/nl_BE/player-rating.json';
import postComment from '@cms/i18n/locale/nl_BE/post-comment.json';
import premium from '@cms/i18n/locale/nl_BE/premium.json';
import profile from '@cms/i18n/locale/nl_BE/profile.json';
import relatedNews from '@cms/i18n/locale/nl_BE/related-news.json';
import search from '@cms/i18n/locale/nl_BE/search.json';
import secure from '@cms/i18n/locale/nl_BE/secure.json';
import sidebar from '@cms/i18n/locale/nl_BE/sidebar.json';
import standing from '@cms/i18n/locale/nl_BE/standing.json';
import stats from '@cms/i18n/locale/nl_BE/stats.json';
import subscribe from '@cms/i18n/locale/nl_BE/subscribe.json';
import uploadSpots from '@cms/i18n/locale/nl_BE/upload-spots.json';
import url from '@cms/i18n/locale/nl_BE/url.json';
import user from '@cms/i18n/locale/nl_BE/user.json';
import videos from '@cms/i18n/locale/nl_BE/videos.json';

import { Ns } from './types';

export const I18N_RESOURCES: Record<Ns, any> = {
    [Ns.Actions]: actions,
    [Ns.Articleblock]: articleblock,
    [Ns.Articles]: articles,
    [Ns.Author]: author,
    [Ns.Betting]: betting,
    [Ns.Comments]: comments,
    [Ns.Common]: common,
    [Ns.Competitions]: competitions,
    [Ns.Components]: components,
    [Ns.Contact]: contact,
    [Ns.CreatePost]: createPost,
    [Ns.Datetime]: datetime,
    [Ns.Error]: error,
    [Ns.Footer]: footer,
    [Ns.Image]: image,
    [Ns.Livescores]: livescores,
    [Ns.Meta]: meta,
    [Ns.Names]: names,
    [Ns.Newslist]: newslist,
    [Ns.PlayerRating]: playerRating,
    [Ns.PostComment]: postComment,
    [Ns.Premium]: premium,
    [Ns.Profile]: profile,
    [Ns.RelatedNews]: relatedNews,
    [Ns.Search]: search,
    [Ns.Secure]: secure,
    [Ns.Sidebar]: sidebar,
    [Ns.Standing]: standing,
    [Ns.Stats]: stats,
    [Ns.Subscribe]: subscribe,
    [Ns.Url]: url,
    [Ns.UploadSpots]: uploadSpots,
    [Ns.User]: user,
    [Ns.Videos]: videos,
};
